import React, { useState, useRef } from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaLock, FaArrowLeft } from "react-icons/fa";
import Spinner from "../../components/Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";
import LogoImage from "../../assets/images/logo.png";
import { Config } from "../../Config";
import { emptyCart, removeUser } from "../../Redux/Actions";
import "./ResetPassword.scss";
import "./Responsive.scss";

const Forgot = (props) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showSpiner, setShowSpiner] = useState(false);
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const refRecaptcha = useRef(null);

  const currentPasswordHandler = (e) => {
    setCurrentPassword(e.target.value);
  };

  const newPasswordHandler = (e) => {
    setNewPassword(e.target.value);
  };

  const passwordConfirmHandler = (e) => {
    setPasswordConfirm(e.target.value);
  };

  // const recaptchHandler = (e) => {
  //     console.log(e);
  // }

  const resetPasswordHandler = () => {
    if (newPassword !== passwordConfirm) {
      toast.error("کلمه عبور جدید و تکرار کلمه عبور جدید یکی نیستند!");
    } else {
      setShowSpiner(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

      var raw = JSON.stringify({
        OldPassword: currentPassword,
        Password: newPassword,
        PasswordConfirm: passwordConfirm,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/Account/ChangePassword", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            setShowSpiner(false);
            toast.success(<div>{result.messages}</div>);
            if (dispatch(removeUser(user[0]))) {
              dispatch(emptyCart(cart));
              document.cookie = "rememberMe=false;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
            }
            setTimeout(() => {
              props.history.push("/login");
            }, 5000);
          } else {
            toast.error(<div>{result.messages}</div>);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const goBackHandler = () => {
    props.history.push("/");
  };

  return (
    <section className="loginWrapper">
      <Helmet>
        {/* <title>ایران رگالو | تغییر کلمه عبور</title> */}
        <title>{Config.helmetTitle} | تغییر کلمه عبور</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="rightSide">
        <span className="goBack" onClick={goBackHandler}>
          <FaArrowLeft />
          &nbsp;صفحه اصلی
        </span>
        <div className="logo">
          <Link to="/">
            <img src={LogoImage} alt="logo" />
          </Link>
          <p className="pageTitle">تغییر کلمه عبور رمز ثابت</p>
        </div>
        <div className="formWrapper">
          <div className="formGroup">
            <div className="caption">
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => currentPasswordHandler(e)}
                id="currentPassword"
                placeholder=""
              />
              <span className="placeholder">کلمه عبور فعلی</span>
              <FaLock className="loginInputIcon" />
            </div>
          </div>
          <div className="formGroup">
            <div className="caption">
              <input
                type="password"
                value={newPassword}
                onChange={(e) => newPasswordHandler(e)}
                id="newPassword"
                placeholder=""
              />
              <span className="placeholder">کلمه عبور جدید</span>
              <FaLock className="loginInputIcon" />
            </div>
          </div>
          <div className="formGroup">
            <div className="caption">
              <input
                type="password"
                value={passwordConfirm}
                onChange={(e) => passwordConfirmHandler(e)}
                id="passwordConfirm"
                placeholder=""
              />
              <span className="placeholder">تکرار کلمه عبور جدید</span>
              <FaLock className="loginInputIcon" />
            </div>
          </div>
          <div className="formGroup">
            <ReCAPTCHA size="invisible" sitekey="6LfO7RAlAAAAAMcpWRyrmUNJYqmrl64Dp-h9u4Qt" ref={refRecaptcha} />
            {/* <ReCAPTCHA size="invisible" sitekey="6Lfgov0bAAAAAFGd8c6ALNbuFDyrElRKdUukingY" onChange={recaptchHandler} /> */}
          </div>
          <div className="formGroup">
            <button className="btnLogin" onClick={resetPasswordHandler}>
              {showSpiner ? <Spinner color="#fff" /> : "تغییر کلمه عبور"}
            </button>
          </div>
        </div>
      </div>
      <div className="leftSide"></div>
    </section>
  );
};

export default React.memo(withRouter(Forgot));
